import { Facebook, Instagram, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';
import logo from '../assets/GBA.png';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const resetScrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <Link to="/" onClick={resetScrollToTop}>
              <img src={logo} alt="Global Black Art" width={240} height={120} decoding="async" className="h-30 w-auto rounded-lg mb-4" />
            </Link>
            <p className="text-gray-400">
              Curating exceptional artworks from talented artists around the world.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" onClick={resetScrollToTop} className="text-gray-400 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/gallery" onClick={resetScrollToTop} className="text-gray-400 hover:text-white transition-colors">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/blog" onClick={resetScrollToTop} className="text-gray-400 hover:text-white transition-colors">
                  Articles
                </Link>
              </li>
              <li>
                <Link to="/open-call" onClick={resetScrollToTop} className="text-gray-400 hover:text-white transition-colors">
                  Open Call
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" onClick={resetScrollToTop} className="text-gray-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={resetScrollToTop} className="text-gray-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Connect</h3>
            <p className="text-gray-400">
              Stay updated with our latest posts and news.
            </p>
            <div className="mt-4 flex items-center gap-2">
              <a
                href="https://www.instagram.com/globalblackart_/"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="text-gray-400 transition-colors hover:text-white p-2 min-w-11 min-h-11 inline-flex items-center justify-center"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61585444594178#"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                className="text-gray-400 transition-colors hover:text-white p-2 min-w-11 min-h-11 inline-flex items-center justify-center"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.linkedin.com/company/global-black-art/?viewAsMember=true"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
                className="text-gray-400 transition-colors hover:text-white p-2 min-w-11 min-h-11 inline-flex items-center justify-center"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {currentYear} GLOBAL BLACK ART. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
